/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import { saveAs } from "file-saver";
import { useDispatch, useSelector } from "react-redux";
import { addFile, clearFiles } from "../../../../actions/file";
import Lottie from "react-lottie";
import LottieNotFound from "../../../../animations/lottie_not_found.json";
import ScrollBars from "../../../../common_components/ScrollBars";
import {
  ValidatePermissions,
  ValidateStatus,
} from "../../../../utils/permissions";

const useStyles = makeStyles((theme) => ({
  divMain: {
    flexGrow: 1,
  },
  gridFile: {
    padding: theme.spacing(3),
    height: "280px",
    borderRadius: "16px",
    backgroundColor: "#2d3034",
  },
  trackVertical: {
    height: "95%",
    right: 0,
    width: "10px !important",
  },

  thumbVertical: {
    backgroundColor: "#2d3034",
    height: "100%",
    right: 0,
    width: "8px !important",
    borderRadius: "8px",
  },
}));

export default function CardFileEmployee(props) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const files = [
    ...new Map(props.files?.map((item) => [item["filename"], item])).values(),
  ];

  const handleEdit = () => {
    props.setStep(2);
    props.setScreen(5);
    // dispatch(clearFiles());
    // props.files.map((file, index) =>
    //   dispatch(
    //     addFile({
    //       name: file.filename,
    //       url: file.file,
    //       originalName: file.originalName,
    //       process: "db",
    //     })
    //   )
    // );
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: LottieNotFound,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className={classes.divMain}>
      <Grid item xs={12} className={classes.gridFile}>
        <Grid container direction="row">
          <Grid item xs={10}>
            <Typography
              style={{
                fontFamily: "Roboto",
                fontSize: 22,
                fontWeight: 500,
                color: "#fff",
              }}
            >
              Expediente trabajador
            </Typography>
          </Grid>
          {ValidatePermissions("editar") &&
            ValidateStatus(props.statusDemek, user) && (
              <Grid
                item
                xs={2}
                container
                direction="row"
                justifyContent="flex-end"
              >
                <Typography
                  onClick={() =>
                    history.push(
                      `/dashboard/empleados/editar/${localStorage.getItem(
                        "idEmployee"
                      )}`
                    )
                  }
                  style={{
                    fontFamily: "Roboto",
                    fontSize: 18,
                    fontWeight: 500,
                    color: "#d233ff",
                    cursor: "pointer",
                  }}
                >
                  Editar
                </Typography>
              </Grid>
            )}
        </Grid>

        {files.length > 0 ? (
          <ScrollBars style={{ height: "90%" }} color="#212429">
            <Grid container direction="row" style={{ marginTop: 20 }}>
              {files &&
                files.map((file, index) => (
                  <Grid
                    item
                    container
                    direction="row"
                    justifyContent="space-between"
                    style={{ marginTop: 10, paddingRight: 20 }}
                    key={index}
                  >
                    <Typography
                      style={{
                        fontFamily: "Roboto",
                        fontSize: 18,
                        color: "#c1c1c1",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        maxWidth: "50%",
                      }}
                    >
                      {file.filename}
                    </Typography>

                    <Typography
                      onClick={() => saveAs(file.file, file.originalName)}
                      style={{
                        fontFamily: "Roboto",
                        fontSize: 18,
                        fontWeight: 500,
                        color: "#fff",
                        cursor: "pointer",
                        textDecorationLine: "underline",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        maxWidth: "50%",
                      }}
                    >
                      {file.originalName}
                    </Typography>
                  </Grid>
                ))}
            </Grid>
          </ScrollBars>
        ) : (
          <Grid container direction="column" style={{ margin: "auto" }}>
            <Lottie options={defaultOptions} height={149} width={164} />
            <Typography
              style={{
                fontFamily: "Roboto",
                fontSize: 16,
                textAlign: "center",
                color: "#c1c1c1",
              }}
            >
              Sin expediente de archivos
            </Typography>
          </Grid>
        )}
      </Grid>
    </div>
  );
}
